module.exports = __webpack_public_path__ + "static/img/hw.4f8cfc16.png";